// import React from 'react';
// import { Link } from 'react-router-dom';
// import '../App.css'; // Ensure this path is correct

// const Navbar = () => {
//     return (
//         <nav className="navbar navbar-expand-lg navbar-light bg-light">
//             <div className="container-fluid">
//                 <div className="navbar-brand-container">
                   
//                     <Link className="navbar-brand" to="/"> <img src="./images/quran.jpg" alt="Logo" className="navbar-logo" style={{height:'31px',marginLeft:'70px',marginTop:'10px'}} />Al-<span style={{color:'orange'}}>Quran academy</span></Link>
//                 </div>
//                 <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
//                     <span className="navbar-toggler-icon"></span>
//                 </button>
//                 <div className="collapse navbar-collapse" id="navbarNav">
//                     <ul className="navbar-nav mx-auto" style={{fontSize:'18px',fontFamily:'fantasy'}}>
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/"><i className="fa-solid fa-house" style={{marginRight:'3px'}}></i>Home</Link>
//                         </li>
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/about"><i className="fas fa-info-circle" style={{marginRight:'3px'}}></i>About</Link>
//                         </li>
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/courses"><i className="fas fa-book" style={{marginRight:'3px'}}></i>Courses</Link>
//                         </li> 
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/Course Description"><i className="fas fa-book" style={{marginRight:'3px'}}></i>Course Description</Link>
//                         </li>
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/pricing"><i className="fas fa-tags" style={{marginRight:'3px'}}></i>Pricing</Link>
//                         </li> 
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/FAQ"><i className="fas fa-tags" style={{marginRight:'3px'}}></i>FAQ</Link>
//                         </li>
//                         <li className="nav-item slide-in">
//                             <Link className="nav-link" to="/contact-us"><i className="fas fa-envelope" style={{marginRight:'3px'}}></i>Contact Us</Link>
//                         </li>
//                     </ul>
//                 </div>
//             </div>
//         </nav>
//     );
// };

// export default Navbar;
import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/"><img src='./images/card12.jpeg' alt='' style={{height:'30px'}  }></img>AL-Quran <span style={{color:'orange'}}>Academy</span></Link>
      </div>
      <div className={`menu-toggle ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="hamburger"></div>
      </div>
      <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/courses">Courses</Link></li>
        <li><Link to="/pricing">Pricing</Link></li>
       
        <li><Link to="/FAQ">FAQ</Link></li>
        <li><Link to="/Blogs">Blogs</Link></li>
        <li><Link to="/contact-us">Contact us</Link></li> 
      </ul>
    </nav>
  );
};

export default Navbar;



